// src/utils/validation.js
// Centralized validation logic

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@\s\.]+(\.[^\s@\s\.]+)*@[^\s@\s\.]+(\.[^\s@\s\.]+)+$/;
  return Boolean(email) && emailRegex.test(email) && email.trim().length <= 254;
};

export const validateRequired = (value) => {
  return Boolean(value) && value.toString().trim().length > 0;
};

export const validateMinLength = (value, minLength) => {
  return Boolean(value) && value.toString().trim().length >= minLength;
};

export const validateMaxLength = (value, maxLength) => {
  return !value || value.toString().trim().length <= maxLength;
};

export const validateContactForm = (formData) => {
  const errors = {};

  if (!validateRequired(formData.name)) {
    errors.name = 'Name is required';
  }

  if (!validateRequired(formData.email)) {
    errors.email = 'Email is required';
  } else if (!validateEmail(formData.email)) {
    errors.email = 'Please enter a valid email address';
  } else if (!validateMaxLength(formData.email, 254)) {
    errors.email = 'Email must be 254 characters or fewer';
  }

  if (!validateRequired(formData.businessSize)) {
    errors.businessSize = 'Please select your business size';
  }

  if (!validateRequired(formData.message)) {
    errors.message = 'Please tell us about your project';
  } else if (!validateMinLength(formData.message, 10)) {
    errors.message = 'Please provide at least 10 characters';
  } else if (!validateMaxLength(formData.message, 1000)) {
    errors.message = 'Message must be 1000 characters or fewer';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
